jQuery(document).ready(function ($) {
    $('.characteristics-accordion .characteristics-header').on('click', function () {
        const item = $(this).closest('.characteristics-item');
        const container = item.closest('.characteristics-accordion');

        container.find('.characteristics-item').removeClass('open');
        container.find('.characteristics-content').slideUp();

        item.addClass('open');
        item.find('.characteristics-content').slideDown();

        const newImg = item.data('featured-img');
        if (newImg) {
            $('#characteristics-featured-img').attr('src', newImg);
        }
    });
});
